import { render, staticRenderFns } from "./FaultDrawer.vue?vue&type=template&id=20f49582&scoped=true"
import script from "./FaultDrawer.vue?vue&type=script&lang=js"
export * from "./FaultDrawer.vue?vue&type=script&lang=js"
import style0 from "./FaultDrawer.vue?vue&type=style&index=0&id=20f49582&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f49582",
  null
  
)

export default component.exports